const PROMPT_EXAMPLES = [
    "I sell handmade candles and need a homepage that builds trust",
    "I sell premium coffee — a page that drives first orders",
    "I sell organic skincare for sensitive skin",
    "I sell minimalist leather bags and want more add-to-carts"
];

const Homepage = {
    init() {
        this.HeroSearchField.init();

        this.HeroBlu.init();

        this.HeroDevice.init();
    },

    HeroSearchField: {
        init() {
            this.initPromptBox('#js-search-field', PROMPT_EXAMPLES);
        },

        initPromptBox(selector, phrases, opts = {}) {
            const {
                typeMs = 38,
                holdMs = 1500,
                delMs = 18,
                startDelay = 700,
                readyLength = 4,
            } = opts;

            const field = document.querySelector(selector);

            if (!field) return;

            const state = {
                prompt: field.closest('.hh__prompt'),
                textEl: field.querySelector('span:first-child'),

                phrases,

                phraseIndex: 0,
                charIndex: 0,
                mode: 'start',

                timer: null,

                typeMs,
                holdMs,
                delMs,
                startDelay,
                readyLength,
            };

            this.updateText(state, '');

            state.timer = setTimeout(() => {
                this.tick(state);
            }, 60);

            return {
                destroy: () => clearTimeout(state.timer),
            };
        },

        updateText(state, text) {
            state.textEl.textContent = text;

            if (!text.length) {
                state.textEl.textContent = 'Ask Omnise';
                state.textEl.classList.add('ph');
            } else {
                state.textEl.classList.remove('ph');
            }

            state.prompt?.classList.toggle(
                'is-focus',
                text.length > state.readyLength
            );
        },

        tick(state) {
            const full = state.phrases[state.phraseIndex];

            switch (state.mode) {
                case 'start':
                    this.updateText(state, '');
                    state.mode = 'typing';
                    state.timer = setTimeout(() => this.tick(state), state.startDelay);
                    return;

                case 'typing':
                    state.charIndex++;

                    this.updateText(
                        state,
                        full.slice(0, state.charIndex)
                    );

                    if (state.charIndex >= full.length) {
                        state.mode = 'hold';
                        state.timer = setTimeout(() => this.tick(state), state.holdMs);
                    } else {
                        state.timer = setTimeout(
                            () => this.tick(state),
                            state.typeMs + Math.random() * 30
                        );
                    }

                    return;

                case 'hold':
                    state.mode = 'deleting';
                    state.timer = setTimeout(() => this.tick(state), state.delMs);
                    return;

                case 'deleting':
                    state.charIndex--;

                    this.updateText(
                        state,
                        full.slice(0, Math.max(0, state.charIndex))
                    );

                    if (state.charIndex <= 0) {
                        state.phraseIndex =
                            (state.phraseIndex + 1) % state.phrases.length;

                        state.mode = 'typing';

                        state.timer = setTimeout(() => this.tick(state), 420);
                    } else {
                        state.timer = setTimeout(() => this.tick(state), state.delMs);
                    }

                    return;
            }
        }
    },

    HeroBlu: {
        init() {
            this.steps = document.querySelectorAll('.js-hero-blu-step');

            if (!this.steps.length) return;

            this.active = 0;
            this.start();
        },

        start() {
            this.timer = setInterval(() => {
                this.active = (this.active + 1) % this.steps.length;
                this.update();
            }, 2500);
        },

        update() {
            this.steps.forEach((step, index) => {
                step.classList.toggle('is-active', index === this.active);
            });
        }
    },

    HeroDevice: {
        init() {
            this.buttons = document.querySelectorAll('.js-hero-device');
            this.canvas = document.getElementById('js-hero-canvas');

            if (!this.buttons.length || !this.canvas) return;

            this.buttons.forEach(button => {
                button.addEventListener('click', () => this.changeDevice(button));
            });
        },

        changeDevice(activeButton) {
            // Active button
            this.buttons.forEach(button => {
                button.classList.toggle('is-active', button === activeButton);
            });

            // Toggle mobile class
            const isMobile = activeButton.dataset.type.toLowerCase() === 'mobile';
            this.canvas.classList.toggle('is-mob', isMobile);
        }
    }

};

document.addEventListener('DOMContentLoaded', () => {
    Homepage.init();
});